/**
 * Created by Ning Jiang on 3/28/2019.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {NudgeSpinReelPartAnimator} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeSpinReelPartAnimator";
import {PPReelController} from "./PPReelController";

export class PPReelPartAnimator extends NudgeSpinReelPartAnimator {

    private _symbolNumTop:number;
    private _defaultStep:number;

    constructor(reelId:number) {
        super(reelId);

        this._symbolNumTop = GameConfig.instance.SYMBOLS_NUM_IN_REEL[0] + GameConfig.instance.SYMBOLS_NUM_IN_REEL[1] + GameConfig.instance.SYMBOLS_NUM_IN_REEL[2];
        this._defaultStep = PPReelController.SYM_SIZE[3].height + PPReelController.SYM_SIZE[3].padding;
    }

    public get symStep():number {
        return this._symbolsToAnimate[this._symbolNumTop].symHeight + this._symbolsToAnimate[this._symbolNumTop - 1].bottomPadding;
    }

    protected initTargetPositions():void {
        this._targetPositions = [];
        let targetPosition:number;
        const positionsNumTotal:number = ArrayHelper.arraySum(GameConfig.instance.SYMBOLS_NUM_IN_REEL) + 1;
        const positionsNumTop:number = this._symbolNumTop + 1;
        for(let i:number = 0; i < positionsNumTotal; i++) {
            targetPosition = this.symStep * (i - positionsNumTop) + this._symHeight / 2 + this._symBottomPadding;
            this._targetPositions.push(targetPosition);
        }
        // Logger.logDev(`init targetPositions = ${this._targetPositions.toString()}`);
    }

    protected resetSymbolsPosition():void {
        for(let i:number = 1; i < this._symbolsToAnimate.length; i++) {
            this._targetPositions[i] = this._symbolsToAnimate[i].y;
        }
        this._targetPositions[0] = this._targetPositions[1] - this._symbolsToAnimate[1].symHeight / 2 - this._symbolsToAnimate[0].symHeight / 2 - this._symbolsToAnimate[0].bottomPadding;

        // Logger.logDev(`targetPositions = ${this._targetPositions.toString()}`);
        super.resetSymbolsPosition();
    }

    protected resetSymbolsPositionBeforeNudgeUp():void {
        // Logger.logDev(`symbols positions before = ${this._symbolsToAnimate.map(s => s.y).join()}`);
        this._symbolsToAnimate.forEach((symbol:StateReelSymbol, index:number) => {
            this._targetPositions[index] = symbol.y - this.symStep;
        });
        // Logger.logDev(`targetPositions after = ${this._targetPositions.join()}`);
        super.resetSymbolsPositionBeforeNudgeUp();
        // Logger.logDev(`symbols positions after = ${this._symbolsToAnimate.map(s => s.y).join()}`);
    }

    protected calculateStartSpinSpeed():number {
        return this.translateStepSpeed(super.calculateStartSpinSpeed());
    }

    protected calculateSpinSpeed():number {
        return this.translateStepSpeed(super.calculateSpinSpeed());
    }

    protected calculationStopSpinSpeed():number {
        return this.translateStepSpeed(super.calculationStopSpinSpeed());
    }

    private translateStepSpeed(speed:number):number {
        return MathHelper.roundToDecimals(speed * this.symStep / this._defaultStep, 4);
    }
}